import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, unref as _unref, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "employees-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = { class: "page-title-wrapper" }
const _hoisted_5 = { class: "active-count-chip" }
const _hoisted_6 = { class: "header-right" }
const _hoisted_7 = { class: "filter-row" }
const _hoisted_8 = { class: "employee-name-cell" }
const _hoisted_9 = { class: "avatar-text" }
const _hoisted_10 = { class: "employee-name" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 1,
  class: "doc-indicator"
}
const _hoisted_13 = {
  key: 2,
  class: "no-doc-indicator"
}
const _hoisted_14 = { class: "action-buttons" }
const _hoisted_15 = { class: "header-content" }
const _hoisted_16 = { class: "avatar-initial" }
const _hoisted_17 = { class: "header-info" }
const _hoisted_18 = { class: "job-badge" }
const _hoisted_19 = {
  key: 0,
  class: "detail-sections"
}
const _hoisted_20 = { class: "detail-section" }
const _hoisted_21 = { class: "section-header" }
const _hoisted_22 = { class: "info-table" }
const _hoisted_23 = { class: "info-row" }
const _hoisted_24 = { class: "info-value" }
const _hoisted_25 = { class: "info-row" }
const _hoisted_26 = { class: "info-value" }
const _hoisted_27 = { class: "info-row" }
const _hoisted_28 = { class: "info-value birth-number-value" }
const _hoisted_29 = {
  key: 0,
  class: "ssn-value"
}
const _hoisted_30 = {
  key: 1,
  class: "ssn-masked"
}
const _hoisted_31 = {
  key: 1,
  class: "not-registered"
}
const _hoisted_32 = { class: "info-row" }
const _hoisted_33 = { class: "info-value" }
const _hoisted_34 = { class: "job-chip" }
const _hoisted_35 = { class: "detail-section" }
const _hoisted_36 = { class: "section-header" }
const _hoisted_37 = { class: "info-table" }
const _hoisted_38 = { class: "info-row" }
const _hoisted_39 = { class: "info-value" }
const _hoisted_40 = {
  key: 0,
  class: "phone-value"
}
const _hoisted_41 = {
  key: 1,
  class: "not-registered"
}
const _hoisted_42 = { class: "info-row" }
const _hoisted_43 = { class: "info-value" }
const _hoisted_44 = {
  key: 0,
  class: "email-value"
}
const _hoisted_45 = {
  key: 1,
  class: "not-registered"
}
const _hoisted_46 = { class: "info-row" }
const _hoisted_47 = { class: "info-value" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 1,
  class: "not-registered"
}
const _hoisted_50 = { class: "detail-section" }
const _hoisted_51 = { class: "section-header" }
const _hoisted_52 = { class: "info-table" }
const _hoisted_53 = { class: "info-row" }
const _hoisted_54 = { class: "info-value" }
const _hoisted_55 = {
  key: 0,
  class: "date-value"
}
const _hoisted_56 = {
  key: 1,
  class: "not-registered"
}
const _hoisted_57 = { class: "info-row" }
const _hoisted_58 = { class: "info-value" }
const _hoisted_59 = {
  key: 0,
  class: "date-value resigned"
}
const _hoisted_60 = {
  key: 1,
  class: "active-status"
}
const _hoisted_61 = { class: "detail-section account-section" }
const _hoisted_62 = { class: "section-header" }
const _hoisted_63 = { class: "account-info-box" }
const _hoisted_64 = {
  key: 0,
  class: "account-status-card registered"
}
const _hoisted_65 = { class: "account-details" }
const _hoisted_66 = { class: "account-id" }
const _hoisted_67 = {
  key: 1,
  class: "account-status-card unregistered"
}
const _hoisted_68 = {
  key: 1,
  class: "edit-form"
}
const _hoisted_69 = { class: "form-section" }
const _hoisted_70 = { class: "compact-field read-only-field" }
const _hoisted_71 = { class: "read-only-value" }
const _hoisted_72 = { class: "compact-field read-only-field" }
const _hoisted_73 = { class: "read-only-value" }
const _hoisted_74 = { class: "compact-field" }
const _hoisted_75 = { class: "birth-number-input-group" }
const _hoisted_76 = { class: "field-hint" }
const _hoisted_77 = {
  key: 0,
  class: "field-action"
}
const _hoisted_78 = { class: "compact-field" }
const _hoisted_79 = { class: "form-section" }
const _hoisted_80 = { class: "compact-field" }
const _hoisted_81 = { class: "compact-field" }
const _hoisted_82 = { class: "form-section" }
const _hoisted_83 = { class: "compact-field" }
const _hoisted_84 = { class: "address-input-group" }
const _hoisted_85 = { class: "compact-field" }
const _hoisted_86 = { class: "form-section" }
const _hoisted_87 = { class: "compact-field" }
const _hoisted_88 = { class: "compact-field" }
const _hoisted_89 = { class: "delete-warning" }
const _hoisted_90 = { class: "text-body-2 text-grey-darken-1" }
const _hoisted_91 = { class: "employee-info-box" }
const _hoisted_92 = { class: "avatar-text" }
const _hoisted_93 = { class: "employee-name" }
const _hoisted_94 = { class: "employee-job" }
const _hoisted_95 = { class: "credential-form" }
const _hoisted_96 = { class: "compact-field" }
const _hoisted_97 = { class: "id-input-group" }
const _hoisted_98 = ["disabled"]
const _hoisted_99 = ["disabled"]
const _hoisted_100 = { class: "compact-field" }
const _hoisted_101 = { class: "password-input-wrapper" }
const _hoisted_102 = ["type", "disabled"]
const _hoisted_103 = { class: "compact-field" }
const _hoisted_104 = { class: "password-input-wrapper" }
const _hoisted_105 = ["type", "disabled"]
const _hoisted_106 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_107 = {
  key: 1,
  class: "empty-documents"
}
const _hoisted_108 = {
  key: 2,
  class: "document-list"
}
const _hoisted_109 = ["onClick"]
const _hoisted_110 = { class: "doc-info" }
const _hoisted_111 = { class: "doc-title" }
const _hoisted_112 = { class: "doc-date" }
const _hoisted_113 = { class: "resignation-detail-header" }
const _hoisted_114 = { class: "resignation-detail-content" }
const _hoisted_115 = { class: "detail-form" }
const _hoisted_116 = { class: "form-row" }
const _hoisted_117 = { class: "form-value" }
const _hoisted_118 = { class: "form-row" }
const _hoisted_119 = { class: "form-value" }
const _hoisted_120 = { class: "form-row" }
const _hoisted_121 = { class: "form-value" }
const _hoisted_122 = { class: "form-row" }
const _hoisted_123 = { class: "form-value reason" }
const _hoisted_124 = { class: "detail-body" }
const _hoisted_125 = { class: "resign-date" }
const _hoisted_126 = { class: "submit-date" }
const _hoisted_127 = { class: "signature-section" }
const _hoisted_128 = {
  key: 0,
  class: "signature-image"
}
const _hoisted_129 = ["src"]
const _hoisted_130 = { class: "status-section" }
const _hoisted_131 = ["disabled"]
const _hoisted_132 = { class: "bulk-settings-section" }
const _hoisted_133 = { class: "settings-row" }
const _hoisted_134 = { class: "compact-field" }
const _hoisted_135 = ["disabled"]
const _hoisted_136 = { class: "field-hint" }
const _hoisted_137 = { class: "compact-field" }
const _hoisted_138 = ["disabled"]
const _hoisted_139 = { class: "rule-info-box" }
const _hoisted_140 = { class: "duplicate-check-section" }
const _hoisted_141 = { class: "bulk-employee-section" }
const _hoisted_142 = { class: "section-header" }
const _hoisted_143 = { class: "bulk-actions" }
const _hoisted_144 = { class: "bulk-employee-list" }
const _hoisted_145 = { class: "bulk-employee-table-wrapper" }
const _hoisted_146 = { class: "bulk-employee-table" }
const _hoisted_147 = { class: "checkbox-col" }
const _hoisted_148 = ["checked", "indeterminate", "disabled"]
const _hoisted_149 = { class: "checkbox-col" }
const _hoisted_150 = ["checked", "onChange", "disabled"]
const _hoisted_151 = { class: "no-id-badge" }
const _hoisted_152 = {
  key: 0,
  class: "error-reason"
}
const _hoisted_153 = { class: "bulk-summary" }
const _hoisted_154 = { class: "upload-status-section" }
const _hoisted_155 = { class: "upload-status-header" }
const _hoisted_156 = { class: "status-year" }
const _hoisted_157 = { class: "month-status-grid" }
const _hoisted_158 = { class: "month-num" }
const _hoisted_159 = {
  key: 0,
  class: "selected-file-card"
}
const _hoisted_160 = { class: "file-icon" }
const _hoisted_161 = { class: "file-info" }
const _hoisted_162 = { class: "file-name" }
const _hoisted_163 = { class: "file-size" }
const _hoisted_164 = { class: "upload-info-box" }

import { computed, ref, onMounted, nextTick, watch } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import EmployeeFormModal from '@/components/employee/EmployeeFormModal.vue';
import MemberUploadModal from '@/components/employee/MemberUploadModal.vue';
import ScheduleCalendarModal from '@/components/employee/ScheduleCalendarModal.vue';

interface Employee {
  emp_idx?: number;
  emp_code: string;
  emp_id?: string;
  m_sisul_code: string;
  emp_name: string;
  emp_birth: string;
  emp_birth_number?: string;
  emp_job: string;
  emp_in_date?: string;
  emp_out_date?: string;
  emp_phone?: string;
  emp_email?: string;
  emp_addr?: string;
  emp_addr_detail?: string;
  emp_wdate?: string;
  emp_rdate?: string;
  emp_status?: 'ACTIVE' | 'INACTIVE' | 'RETIRING';
  has_birth_number?: boolean | number | string;
  doc_count?: number;
  has_resignation?: number;
  resignation_status?: string;
}

// 상태 관리

export default /*@__PURE__*/_defineComponent({
  __name: 'PgmEmployees',
  setup(__props) {

const store = useStore();
const user = computed(() => store.state.user);

const isLoading = ref(false);
const loadingText = ref('로딩 중...');
const detailDialog = ref(false);
const employeeDialog = ref(false);
const deleteDialog = ref(false);
const selectedEmployee = ref<Employee | null>(null);
const editingEmployee = ref<Employee | null>(null);
const employeeToDelete = ref<Employee | null>(null);
const isSaving = ref(false);
const isDeleting = ref(false);
const isEditMode = ref(false);

// 사원 목록
const employees = ref<Employee[]>([]);

// 필터
const filters = ref({
  keyword: '',
  job: null as string | null,
  status: null as 'ACTIVE' | 'INACTIVE' | 'RETIRING' | null
});

// 사원 정보 업로드 관련
const memberUploadDialog = ref(false);

// 일정계획 캘린더 관련
const scheduleCalendarDialog = ref(false);
const selectedEmployeeForSchedule = ref<Employee | null>(null);

// 일정계획 업로드 관련
const scheduleUploadDialog = ref(false);
const scheduleFile = ref<File | null>(null);
const scheduleFileInput = ref<HTMLInputElement | null>(null);
const isScheduleUploading = ref(false);
const isScheduleDragging = ref(false);
const currentYear = new Date().getFullYear();
const scheduleUploadStatus = ref<Record<number, boolean>>({});
const isLoadingScheduleStatus = ref(false);

// 수정 폼 데이터 (상세 모달용)
const editFormData = ref<Employee>({
  emp_code: '',
  m_sisul_code: '',
  emp_name: '',
  emp_birth: '',
  emp_birth_number: '',
  emp_job: '',
  emp_in_date: '',
  emp_out_date: '',
  emp_phone: '',
  emp_email: '',
  emp_addr: '',
  emp_addr_detail: ''
});

// 주민등록번호 입력 상태 (UI용)
const birthNumberFront = ref('');
const birthNumberBack = ref('');

// 주소 검색 관련 (상세 모달 수정 모드용)
const addressDialog = ref(false);
const addressLoading = ref(false);
const postcodeContainer = ref<HTMLDivElement | null>(null);
let daumScriptLoading: Promise<void> | null = null;

// 주민등록번호 복호화 상태
const birthNumberState = ref({
  visible: false,
  loading: false,
  value: ''
});

// 사원 계정 부여 관련
const credentialDialog = ref(false);
const isCheckingId = ref(false);
const isAssigningCredential = ref(false);
const showPassword = ref(false);
const showPasswordConfirm = ref(false);

const credentialState = ref({
  hasAccount: false,
  empId: ''
});

const credentialForm = ref({
  emp_id: '',
  emp_pw: '',
  emp_pw_confirm: ''
});

const idCheckResult = ref({
  checked: false,
  available: false,
  message: ''
});

// 일괄 계정 부여 관련
const bulkCredentialDialog = ref(false);
const isBulkAssigning = ref(false);
const bulkSelectedEmployees = ref<number[]>([]);
const bulkCredentialForm = ref({
  prefix: '',
  password: '1234'
});

// 중복 검사 관련
const isCheckingDuplicate = ref(false);
const duplicateEmployees = ref<number[]>([]);
const duplicateReasons = ref<Record<number, string>>({});
const duplicateCheckResult = ref({
  checked: false,
  hasError: false,
  message: ''
});

// 옵션
const jobOptions = ['센터장', '사회복지사', '요양보호사', '간호사', '간호조무사', '물리치료사', '작업치료사', '기타'];

// 다운로드 가능한 파일 목록
const downloadableFiles = [
  {
    name: '취업규칙(요양시설)-2025년(협력 노무사 감수).hwp',
    label: '취업규칙 (요양시설) 2025년',
    path: '/files/취업규칙(요양시설)-2025년(협력 노무사 감수).hwp'
  },
  {
    name: '방문요양 요양보호사 근로계약서 샘플 2026년.hwpx',
    label: '근로계약서 샘플 2026년',
    path: '/files/방문요양 요양보호사 근로계약서 샘플 2026년.hwpx'
  }
];

// 파일 다운로드 함수
const downloadFile = (file: { name: string; label: string; path: string }) => {
  const link = document.createElement('a');
  link.href = file.path;
  link.download = file.name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  store.commit('showSnackbar', {
    text: `${file.label} 파일을 다운로드합니다.`,
    color: 'success'
  });
};

const statusOptions = [
  { label: '재직', value: 'ACTIVE' },
  { label: '퇴사/휴직', value: 'INACTIVE' },
  { label: '퇴사 예정', value: 'RETIRING' }
];

// 테이블 헤더
const headers = [
  { title: '이름', value: 'emp_name', sortable: true },
  { title: '직종', value: 'emp_job', sortable: true },
  { title: 'ID', value: 'emp_id', sortable: true },
  { title: '생년월일', value: 'emp_birth', sortable: true },
  { title: '휴대폰번호', value: 'emp_phone', sortable: false },
  { title: '입사일', value: 'emp_in_date', sortable: true },
  { title: '퇴사일', value: 'emp_out_date', sortable: true },
  { title: '문서', value: 'documents', sortable: false, align: 'center' as const },
  { title: '작업', value: 'actions', sortable: false, align: 'center' as const }
];

// 문서 모달 관련
const documentDialog = ref(false);
const selectedEmployeeForDoc = ref<Employee | null>(null);
const employeeDocuments = ref<any[]>([]);
const isLoadingDocuments = ref(false);
const selectedDocument = ref<any>(null);
const documentDetailDialog = ref(false);

// 계산된 속성
const filteredEmployees = computed(() => {
  return employees.value.filter(employee => {
    const keywordMatch =
      !filters.value.keyword ||
      [employee.emp_name, employee.emp_code, employee.emp_phone, employee.emp_email]
        .filter(Boolean)
        .some(field => field?.toLowerCase().includes(filters.value.keyword.toLowerCase()));

    const jobMatch = !filters.value.job || employee.emp_job === filters.value.job;
    const statusMatch = !filters.value.status || employee.emp_status === filters.value.status;

    return keywordMatch && jobMatch && statusMatch;
  });
});

const employeesSummary = computed(() => ({
  total: employees.value.length,
  active: employees.value.filter(emp => emp.emp_status === 'ACTIVE').length,
  inactive: employees.value.filter(emp => emp.emp_status !== 'ACTIVE').length
}));

const isEditFormValid = computed(() => {
  return !!(
    editFormData.value.emp_name &&
    editFormData.value.emp_birth &&
    editFormData.value.emp_job
  );
});

const hasBirthNumberRegistered = computed(() => {
  const value = selectedEmployee.value?.has_birth_number;
  if (value === undefined || value === null) {
    return false;
  }

  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'number') {
    return value > 0;
  }

  if (typeof value === 'string') {
    return value === '1' || value.toLowerCase() === 'true';
  }

  return false;
});

// 생년월일에서 주민등록번호 앞자리 추출 (YYYYMMDD → YYMMDD)
const extractBirthFront = (birth: string): string => {
  if (!birth) return '';
  // YYYYMMDD 형식에서 YYMMDD 추출
  const digitsOnly = birth.replace(/[^\d]/g, '');
  if (digitsOnly.length === 8) {
    return digitsOnly.substring(2, 8);
  }
  return '';
};

// 주민등록번호 포맷팅 (있는 그대로 표시)
const formatBirthNumber = (birthNumber: string, empBirth?: string): string => {
  if (!birthNumber) return '';
  const digitsOnly = birthNumber.replace(/[^\d]/g, '');
  
  // 정상적인 13자리인 경우
  if (digitsOnly.length === 13) {
    return `${digitsOnly.substring(0, 6)}-${digitsOnly.substring(6)}`;
  }
  
  // 7자리(뒷자리만)인 경우: 앞자리 없음 표시
  if (digitsOnly.length === 7) {
    return `(앞자리 없음) ${digitsOnly}`;
  }
  
  // 그 외의 경우 있는 그대로 표시
  if (digitsOnly.length > 0) {
    return digitsOnly;
  }
  
  return '●●●●●●-●●●●●●●';
};

// 주민등록번호 마스킹 텍스트 (항상 마스킹으로 표시)
const getBirthNumberMaskedText = (): string => {
  return '●●●●●●-●●●●●●●';
};

// 주민등록번호 상태 텍스트 (수정 모드용)
const getBirthNumberStatusText = (): string => {
  // has_birth_number 여부로 판단
  if (hasBirthNumberRegistered.value) {
    return '등록됨';
  }
  return '미등록';
};

const isPasswordMatch = computed(() => {
  return credentialForm.value.emp_pw === credentialForm.value.emp_pw_confirm;
});

const isCredentialFormValid = computed(() => {
  return (
    credentialForm.value.emp_id.length >= 4 &&
    credentialForm.value.emp_pw.length >= 4 &&
    isPasswordMatch.value &&
    (idCheckResult.value.checked && idCheckResult.value.available)
  );
});

// 일괄 계정 부여 관련 계산된 속성
// 계정이 없는 재직 중인 사원만 표시
const employeesWithoutAccount = computed(() => {
  return employees.value.filter(emp => 
    emp.emp_status === 'ACTIVE' && 
    (!emp.emp_id || emp.emp_id.trim() === '')
  );
});

const isAllSelected = computed(() => {
  return employeesWithoutAccount.value.length > 0 && 
    bulkSelectedEmployees.value.length === employeesWithoutAccount.value.length;
});

const isPartiallySelected = computed(() => {
  return bulkSelectedEmployees.value.length > 0 && 
    bulkSelectedEmployees.value.length < employeesWithoutAccount.value.length;
});

const bulkIdPreview = computed(() => {
  const prefix = bulkCredentialForm.value.prefix || '접두사';
  return `${prefix}홍길동990101`;
});

const isBulkFormValid = computed(() => {
  return (
    bulkCredentialForm.value.prefix.trim().length > 0 &&
    bulkCredentialForm.value.password.trim().length >= 4 &&
    bulkSelectedEmployees.value.length > 0 &&
    duplicateCheckResult.value.checked &&
    !duplicateCheckResult.value.hasError
  );
});

// 메서드
const fetchEmployees = async () => {
  if (!user.value?.m_sisul_code) {
    console.error('시설 코드가 없습니다.', user.value);
    store.commit('showSnackbar', {
      text: '사용자 정보를 불러올 수 없습니다. 다시 로그인해주세요.',
      color: 'error'
    });
    return;
  }

  try {
    isLoading.value = true;
    loadingText.value = '사원 정보를 불러오는 중...';
    
    const response = await axios.get(`/api/emp/facility/${user.value.m_sisul_code}`, {
      withCredentials: true
    });


    if (response.data.success) {
      employees.value = response.data.data || [];
      
      if (employees.value.length === 0) {
        store.commit('showSnackbar', {
          text: '등록된 사원이 없습니다.',
          color: 'info'
        });
      }
    } else {
      console.error('사원 조회 실패:', response.data.message);
      store.commit('showSnackbar', {
        text: response.data.message || '사원 정보 조회에 실패했습니다.',
        color: 'error'
      });
    }
  } catch (error: any) {
    console.error('사원 조회 중 오류:', error);
    console.error('에러 상세:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      url: error.config?.url
    });
    
    const errorMessage = error.response?.data?.message 
      || error.response?.data?.error
      || error.message
      || '사원 정보 조회 중 오류가 발생했습니다.';
    
    store.commit('showSnackbar', {
      text: errorMessage,
      color: 'error'
    });
  } finally {
    isLoading.value = false;
  }
};

const resetFilters = () => {
  filters.value = {
    keyword: '',
    job: null,
    status: null
  };
};

const getStatusColor = (status?: string) => {
  switch (status) {
    case 'ACTIVE':
      return 'success';
    case 'RETIRING':
      return 'warning';
    case 'INACTIVE':
      return 'error';
    default:
      return 'grey';
  }
};

const getStatusText = (status?: string) => {
  switch (status) {
    case 'ACTIVE':
      return '재직';
    case 'RETIRING':
      return '퇴사예정';
    case 'INACTIVE':
      return '퇴사/휴직';
    default:
      return '-';
  }
};

const formatBirth = (birth: string) => {
  if (!birth || birth.length !== 8) return birth;
  return `${birth.substring(0, 4)}-${birth.substring(4, 6)}-${birth.substring(6, 8)}`;
};

// 문서 날짜 포맷
const formatDocDate = (dateStr: string) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일`;
};

// 퇴사 예정일 포맷
const formatResignDate = (dateStr: string) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일`;
};

// 문서 상태 텍스트
const getDocStatusText = (status: string) => {
  switch (status) {
    case 'submitted': return '제출됨';
    case 'approved': return '승인됨';
    case 'rejected': return '반려됨';
    default: return status;
  }
};

// 사직서 배지 색상
const getResignationBadgeColor = (status: string) => {
  switch (status) {
    case 'submitted': return '#f59e0b'; // 주황색 (대기중)
    case 'approved': return '#dc2626'; // 빨간색 (승인됨)
    case 'rejected': return '#6b7280'; // 회색 (반려됨)
    default: return '#f59e0b';
  }
};

// 사직서 배지 텍스트
const getResignationBadgeText = (status: string) => {
  switch (status) {
    case 'submitted': return '사직서';
    case 'approved': return '사직승인';
    case 'rejected': return '사직반려';
    default: return '사직서';
  }
};

// 문서 모달 열기
const openDocumentDialog = async (employee: Employee) => {
  selectedEmployeeForDoc.value = employee;
  documentDialog.value = true;
  await fetchEmployeeDocuments(employee.emp_idx!);
};

// 사원 문서 조회
const fetchEmployeeDocuments = async (empIdx: number) => {
  isLoadingDocuments.value = true;
  try {
    const response = await axios.get(`/api/emp/documents/${empIdx}`, {
      withCredentials: true
    });
    
    if (response.data.success) {
      employeeDocuments.value = response.data.data || [];
    } else {
      employeeDocuments.value = [];
    }
  } catch (error) {
    console.error('문서 조회 오류:', error);
    employeeDocuments.value = [];
  } finally {
    isLoadingDocuments.value = false;
  }
};

// 문서 상세 보기
const viewDocumentDetail = (doc: any) => {
  selectedDocument.value = doc;
  documentDetailDialog.value = true;
};

// 서명 이미지 URL 생성
const getSignatureUrl = (signaturePath: string) => {
  if (!signaturePath) return '';
  // /emp_sign/파일명.png → /api/emp/emp_sign/파일명.png
  return `/api/emp${signaturePath}`;
};

// 사직서 PDF 다운로드
const downloadResignationPDF = (pdfPath: string) => {
  if (!pdfPath) return;
  // /emp_docs/파일명.pdf → /api/emp/emp_docs/파일명.pdf
  const pdfUrl = `/api/emp${pdfPath}`;
  window.open(pdfUrl, '_blank');
};

const viewEmployeeDetail = async (employee: Employee) => {
  selectedEmployee.value = employee;
  isEditMode.value = false;
  birthNumberState.value = {
    visible: false,
    loading: false,
    value: ''
  };
  birthNumberFront.value = '';
  birthNumberBack.value = '';
  // 계정 정보 초기화 및 조회
  credentialState.value = {
    hasAccount: false,
    empId: ''
  };
  if (employee.emp_idx) {
    await fetchCredentialInfo(employee.emp_idx);
  }
  detailDialog.value = true;
};

// 사원 계정 정보 조회
const fetchCredentialInfo = async (empIdx: number) => {
  try {
    const response = await axios.get(`/api/emp/facility/${empIdx}/credentials`, {
      withCredentials: true
    });

    if (response.data.success && response.data.data) {
      credentialState.value = {
        hasAccount: response.data.data.has_account,
        empId: response.data.data.emp_id || ''
      };
    }
  } catch (error) {
    console.error('계정 정보 조회 오류:', error);
  }
};

// 계정 부여 모달 열기
const openCredentialDialog = () => {
  // 폼 초기화
  credentialForm.value = {
    emp_id: credentialState.value.empId || '',
    emp_pw: '',
    emp_pw_confirm: ''
  };
  idCheckResult.value = {
    checked: credentialState.value.hasAccount && credentialState.value.empId ? true : false,
    available: credentialState.value.hasAccount && credentialState.value.empId ? true : false,
    message: credentialState.value.hasAccount ? '기존 아이디입니다.' : ''
  };
  showPassword.value = false;
  showPasswordConfirm.value = false;
  credentialDialog.value = true;
};

// 계정 부여 모달 닫기
const closeCredentialDialog = () => {
  credentialDialog.value = false;
  credentialForm.value = {
    emp_id: '',
    emp_pw: '',
    emp_pw_confirm: ''
  };
  idCheckResult.value = {
    checked: false,
    available: false,
    message: ''
  };
};

// 아이디 입력 핸들러
const onCredentialIdInput = () => {
  // 아이디가 변경되면 중복 확인 결과 리셋
  // 단, 기존 아이디와 같으면 리셋하지 않음
  if (credentialState.value.hasAccount && credentialForm.value.emp_id === credentialState.value.empId) {
    idCheckResult.value = {
      checked: true,
      available: true,
      message: '기존 아이디입니다.'
    };
  } else {
    idCheckResult.value = {
      checked: false,
      available: false,
      message: ''
    };
  }
};

// 아이디 중복 확인
const checkIdDuplicate = async () => {
  if (!credentialForm.value.emp_id || credentialForm.value.emp_id.length < 4) {
    store.commit('showSnackbar', {
      text: '아이디는 4자 이상 입력해주세요.',
      color: 'warning'
    });
    return;
  }

  // 기존 아이디와 같으면 중복 확인 불필요
  if (credentialState.value.hasAccount && credentialForm.value.emp_id === credentialState.value.empId) {
    idCheckResult.value = {
      checked: true,
      available: true,
      message: '기존 아이디입니다.'
    };
    return;
  }

  try {
    isCheckingId.value = true;
    const response = await axios.get(`/api/emp/check-id/${credentialForm.value.emp_id}`, {
      withCredentials: true
    });

    idCheckResult.value = {
      checked: true,
      available: response.data.available,
      message: response.data.message
    };
  } catch (error: any) {
    console.error('아이디 중복 확인 오류:', error);
    idCheckResult.value = {
      checked: true,
      available: false,
      message: '중복 확인 중 오류가 발생했습니다.'
    };
  } finally {
    isCheckingId.value = false;
  }
};

// 계정 부여/수정 실행
const assignCredentials = async () => {
  if (!isCredentialFormValid.value) return;
  if (!selectedEmployee.value?.emp_idx) {
    store.commit('showSnackbar', {
      text: '사원 정보가 없습니다.',
      color: 'error'
    });
    return;
  }

  try {
    isAssigningCredential.value = true;
    
    const response = await axios.put(
      `/api/emp/facility/${selectedEmployee.value.emp_idx}/credentials`,
      {
        emp_id: credentialForm.value.emp_id,
        emp_pw: credentialForm.value.emp_pw
      },
      { withCredentials: true }
    );

    if (response.data.success) {
      store.commit('showSnackbar', {
        text: response.data.message || '계정이 성공적으로 부여되었습니다.',
        color: 'success'
      });
      
      // 계정 상태 업데이트
      credentialState.value = {
        hasAccount: true,
        empId: credentialForm.value.emp_id
      };
      
      closeCredentialDialog();
    } else {
      store.commit('showSnackbar', {
        text: response.data.message || '계정 부여에 실패했습니다.',
        color: 'error'
      });
    }
  } catch (error: any) {
    console.error('계정 부여 오류:', error);
    store.commit('showSnackbar', {
      text: error.response?.data?.message || '계정 부여 중 오류가 발생했습니다.',
      color: 'error'
    });
  } finally {
    isAssigningCredential.value = false;
  }
};

// 일괄 계정 부여 관련 함수들
const generateBulkId = (emp: Employee): string => {
  if (!bulkCredentialForm.value.prefix) return '-';
  const birthPart = emp.emp_birth ? emp.emp_birth.substring(2, 8) : '';
  return `${bulkCredentialForm.value.prefix}${emp.emp_name}${birthPart}`;
};

const openBulkCredentialDialog = () => {
  bulkCredentialForm.value = {
    prefix: '',
    password: '1234'
  };
  // 미부여 사원 전체 선택
  bulkSelectedEmployees.value = employeesWithoutAccount.value
    .filter(emp => emp.emp_idx !== undefined)
    .map(emp => emp.emp_idx!);
  // 중복 검사 결과 초기화
  duplicateCheckResult.value = {
    checked: false,
    hasError: false,
    message: ''
  };
  duplicateEmployees.value = [];
  duplicateReasons.value = {};
  bulkCredentialDialog.value = true;
};

const closeBulkCredentialDialog = () => {
  bulkCredentialDialog.value = false;
  bulkCredentialForm.value = {
    prefix: '',
    password: '1234'
  };
  bulkSelectedEmployees.value = [];
};

const selectAllEmployees = () => {
  bulkSelectedEmployees.value = employeesWithoutAccount.value
    .filter(emp => emp.emp_idx !== undefined)
    .map(emp => emp.emp_idx!);
};

const deselectAllEmployees = () => {
  bulkSelectedEmployees.value = [];
};

const toggleSelectAll = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.checked) {
    selectAllEmployees();
  } else {
    deselectAllEmployees();
  }
};

const toggleEmployeeSelection = (empIdx: number) => {
  const index = bulkSelectedEmployees.value.indexOf(empIdx);
  if (index === -1) {
    bulkSelectedEmployees.value.push(empIdx);
  } else {
    bulkSelectedEmployees.value.splice(index, 1);
  }
  // 선택 변경 시 중복 검사 결과 초기화
  resetDuplicateCheck();
};

// 중복 검사 결과 초기화
const resetDuplicateCheck = () => {
  duplicateCheckResult.value = {
    checked: false,
    hasError: false,
    message: ''
  };
  duplicateEmployees.value = [];
  duplicateReasons.value = {};
};

// 중복 사유 조회
const getDuplicateReason = (empIdx: number): string => {
  return duplicateReasons.value[empIdx] || '';
};

// 중복 검사 실행
const checkBulkDuplicate = async () => {
  if (!bulkCredentialForm.value.prefix || bulkSelectedEmployees.value.length === 0) {
    store.commit('showSnackbar', {
      text: '접두사를 입력하고 사원을 선택해주세요.',
      color: 'warning'
    });
    return;
  }

  try {
    isCheckingDuplicate.value = true;
    duplicateEmployees.value = [];
    duplicateReasons.value = {};
    
    // 1. 선택된 사원들의 생성될 ID 목록 만들기
    const idList: { empIdx: number; empId: string; empName: string }[] = [];
    for (const empIdx of bulkSelectedEmployees.value) {
      const emp = employees.value.find(e => e.emp_idx === empIdx);
      if (emp) {
        const birthPart = emp.emp_birth ? emp.emp_birth.substring(2, 8) : '';
        idList.push({
          empIdx: empIdx,
          empId: `${bulkCredentialForm.value.prefix}${emp.emp_name}${birthPart}`,
          empName: emp.emp_name
        });
      }
    }

    // 2. 프론트엔드에서 생성될 ID끼리 중복 체크
    const idCount: Record<string, number[]> = {};
    for (const item of idList) {
      if (!idCount[item.empId]) {
        idCount[item.empId] = [];
      }
      idCount[item.empId].push(item.empIdx);
    }

    // 같은 ID가 2개 이상이면 중복
    for (const [id, empIdxList] of Object.entries(idCount)) {
      if (empIdxList.length > 1) {
        for (const empIdx of empIdxList) {
          if (!duplicateEmployees.value.includes(empIdx)) {
            duplicateEmployees.value.push(empIdx);
          }
          duplicateReasons.value[empIdx] = '동일 ID 생성됨';
        }
      }
    }

    // 3. 백엔드에서 기존 ID와 중복 체크
    const response = await axios.post(
      '/api/emp/check-bulk-ids',
      { ids: idList.map(item => ({ empIdx: item.empIdx, empId: item.empId })) },
      { withCredentials: true }
    );

    if (response.data.success && response.data.duplicates) {
      for (const dup of response.data.duplicates) {
        if (!duplicateEmployees.value.includes(dup.empIdx)) {
          duplicateEmployees.value.push(dup.empIdx);
        }
        duplicateReasons.value[dup.empIdx] = dup.reason || '이미 사용 중인 ID';
      }
    }

    // 4. 결과 설정
    if (duplicateEmployees.value.length > 0) {
      duplicateCheckResult.value = {
        checked: true,
        hasError: true,
        message: `${duplicateEmployees.value.length}명의 ID가 중복되었습니다. 빨간색 표시된 사원을 확인해주세요.`
      };
    } else {
      duplicateCheckResult.value = {
        checked: true,
        hasError: false,
        message: '중복된 ID가 없습니다. 계정을 부여할 수 있습니다.'
      };
    }
  } catch (error: any) {
    console.error('중복 검사 오류:', error);
    duplicateCheckResult.value = {
      checked: true,
      hasError: true,
      message: '중복 검사 중 오류가 발생했습니다.'
    };
  } finally {
    isCheckingDuplicate.value = false;
  }
};

const assignBulkCredentials = async () => {
  if (!isBulkFormValid.value) return;

  try {
    isBulkAssigning.value = true;
    
    // 선택된 사원들의 계정 정보 생성
    const credentialsList = bulkSelectedEmployees.value.map(empIdx => {
      const emp = employees.value.find(e => e.emp_idx === empIdx);
      if (!emp) return null;
      
      const birthPart = emp.emp_birth ? emp.emp_birth.substring(2, 8) : '';
      return {
        emp_idx: empIdx,
        emp_id: `${bulkCredentialForm.value.prefix}${emp.emp_name}${birthPart}`,
        emp_pw: bulkCredentialForm.value.password
      };
    }).filter(item => item !== null);

    const response = await axios.post(
      '/api/emp/facility/bulk-credentials',
      { credentials: credentialsList },
      { withCredentials: true }
    );

    if (response.data.success) {
      store.commit('showSnackbar', {
        text: response.data.message || `${credentialsList.length}명의 계정이 성공적으로 부여되었습니다.`,
        color: 'success'
      });
      
      closeBulkCredentialDialog();
      await fetchEmployees();
    } else {
      store.commit('showSnackbar', {
        text: response.data.message || '일괄 계정 부여에 실패했습니다.',
        color: 'error'
      });
    }
  } catch (error: any) {
    console.error('일괄 계정 부여 오류:', error);
    store.commit('showSnackbar', {
      text: error.response?.data?.message || '일괄 계정 부여 중 오류가 발생했습니다.',
      color: 'error'
    });
  } finally {
    isBulkAssigning.value = false;
  }
};

const resetBirthNumberState = () => {
  birthNumberState.value = {
    visible: false,
    loading: false,
    value: ''
  };
  birthNumberBack.value = '';
};

const fetchBirthNumberFromServer = async (): Promise<string | null> => {
  if (!selectedEmployee.value?.emp_idx) {
    return null;
  }

  try {
    birthNumberState.value.loading = true;
    const response = await axios.get(`/api/emp/facility/${selectedEmployee.value.emp_idx}/birth-number`, {
      withCredentials: true
    });

    if (response.data.success && response.data.data?.birthNumber) {
      birthNumberState.value.value = response.data.data.birthNumber;
      return response.data.data.birthNumber;
    }

    store.commit('showSnackbar', {
      text: response.data.message || '등록된 주민등록번호가 없습니다.',
      color: 'info'
    });
    return null;
  } catch (error) {
    console.error('주민등록번호 복호화 오류:', error);
    store.commit('showSnackbar', {
      text: '주민등록번호를 불러오지 못했습니다.',
      color: 'error'
    });
    return null;
  } finally {
    birthNumberState.value.loading = false;
  }
};

const toggleBirthNumberVisibility = async () => {
  if (!hasBirthNumberRegistered.value) {
    return;
  }

  if (birthNumberState.value.visible) {
    birthNumberState.value.visible = false;
    return;
  }

  if (!birthNumberState.value.value) {
    const fetched = await fetchBirthNumberFromServer();
    if (!fetched) {
      return;
    }
  }

  birthNumberState.value.visible = true;
};

const fillBirthNumberForEdit = async () => {
  if (!hasBirthNumberRegistered.value) {
    return;
  }

  if (!birthNumberState.value.value) {
    const fetched = await fetchBirthNumberFromServer();
    if (!fetched) {
      return;
    }
  }

  // 주민등록번호에서 앞자리 6자리 + 뒷자리 7자리 추출
  const fullNumber = birthNumberState.value.value.replace(/[^\d]/g, '');
  if (fullNumber.length === 13) {
    // 전체 13자리가 있으면 앞자리와 뒷자리 분리
    birthNumberFront.value = fullNumber.slice(0, 6);
    birthNumberBack.value = fullNumber.slice(6);
  } else if (fullNumber.length === 7) {
    // 뒷자리만 있는 경우
    birthNumberFront.value = '';
    birthNumberBack.value = fullNumber;
  } else if (fullNumber.length >= 7) {
    birthNumberBack.value = fullNumber.slice(-7);
  }
  store.commit('showSnackbar', {
    text: '주민등록번호를 입력란에 불러왔습니다.',
    color: 'success'
  });
};

const startEdit = async () => {
  if (selectedEmployee.value) {
    editFormData.value = { ...selectedEmployee.value, emp_birth_number: '' };
    // 앞자리, 뒷자리 모두 빈값으로 초기화
    birthNumberFront.value = '';
    birthNumberBack.value = '';
    isEditMode.value = true;
    
    // 주민등록번호가 등록되어 있으면 자동으로 불러오기
    if (hasBirthNumberRegistered.value) {
      const fetched = await fetchBirthNumberFromServer();
      if (fetched) {
        const fullNumber = birthNumberState.value.value.replace(/[^\d]/g, '');
        if (fullNumber.length === 13) {
          birthNumberFront.value = fullNumber.slice(0, 6);
          birthNumberBack.value = fullNumber.slice(6);
        } else if (fullNumber.length === 7) {
          birthNumberFront.value = '';
          birthNumberBack.value = fullNumber;
        }
      }
    }
  }
};

const cancelEdit = () => {
  isEditMode.value = false;
  birthNumberFront.value = '';
  birthNumberBack.value = '';
  editFormData.value = {
    emp_code: '',
    m_sisul_code: '',
    emp_name: '',
    emp_birth: '',
    emp_birth_number: '',
    emp_job: '',
    emp_in_date: '',
    emp_out_date: '',
    emp_phone: '',
    emp_email: '',
    emp_addr: '',
    emp_addr_detail: ''
  };
};

const saveEdit = async () => {
  if (!isEditFormValid.value) return;
  
  isSaving.value = true;
  
  try {
    // 주민등록번호 조합: 앞자리 + 뒷자리
    const fullBirthNumber = (birthNumberFront.value && birthNumberBack.value) 
      ? (birthNumberFront.value + birthNumberBack.value) 
      : '';
    
    const response = await axios.post('/api/calc/employee', {
      ...editFormData.value,
      emp_birth_number: fullBirthNumber,
      m_sisul_code: user.value?.m_sisul_code
    }, {
      withCredentials: true
    });
    
    if (response.data.success) {
      // 입사일이 변경된 경우, leb_member_info 테이블도 업데이트
      if (selectedEmployee.value && editFormData.value.emp_in_date !== selectedEmployee.value.emp_in_date) {
        try {
          await axios.post('/api/emp/update-start-date', {
            m_sisul_code: user.value?.m_sisul_code,
            emp_name: editFormData.value.emp_name,
            emp_birth: editFormData.value.emp_birth,
            emp_in_date: editFormData.value.emp_in_date
          }, {
            withCredentials: true
          });
        } catch (startDateError) {
          console.warn('급여 테이블 입사일 업데이트 실패:', startDateError);
        }
      }
      
      let message = '사원 정보가 수정되었습니다.';
      
      // 응답에 사원코드가 포함되어 있으면 표시 (신규 생성된 경우)
      if (response.data.empCode) {
        message += ` (사원코드: ${response.data.empCode})`;
      }
      
      store.commit('showSnackbar', {
        text: message,
        color: 'success'
      });
      
      // 사원 목록 새로고침
      await fetchEmployees();
      
      // 수정된 사원 정보로 selectedEmployee 업데이트
      const updatedEmployee = employees.value.find(
        emp => emp.emp_idx === editFormData.value.emp_idx
      );
      if (updatedEmployee) {
        selectedEmployee.value = updatedEmployee;
      }
      
      // 수정 모드 종료 (상세 보기 모드로 전환)
      isEditMode.value = false;
      birthNumberFront.value = '';
      birthNumberBack.value = '';
    } else {
      store.commit('showSnackbar', {
        text: response.data.message || '저장에 실패했습니다.',
        color: 'error'
      });
    }
  } catch (error: any) {
    console.error('사원 저장 오류:', error);
    store.commit('showSnackbar', {
      text: error.response?.data?.message || '사원 저장 중 오류가 발생했습니다.',
      color: 'error'
    });
  } finally {
    isSaving.value = false;
  }
};

const openEmployeeDialog = (employee: Employee | null) => {
  editingEmployee.value = employee;
  employeeDialog.value = true;
};

const handleEmployeeSaved = async () => {
  editingEmployee.value = null;
  await fetchEmployees();
};

const onEditPhoneInput = (e: Event) => {
  const target = e.target as HTMLInputElement;
  const digits = target.value.replace(/[^\d]/g, '').slice(0, 11);
  
  let formatted = digits;
  if (digits.length > 3 && digits.length <= 7) {
    formatted = `${digits.slice(0,3)}-${digits.slice(3)}`;
  } else if (digits.length > 7) {
    formatted = `${digits.slice(0,3)}-${digits.slice(3,7)}-${digits.slice(7)}`;
  }
  
  editFormData.value.emp_phone = formatted;
};

const onEditBirthNumberFrontInput = (e: Event) => {
  const target = e.target as HTMLInputElement;
  const value = target.value.replace(/[^\d]/g, '');
  birthNumberFront.value = value;
};

const onEditBirthNumberBackInput = (e: Event) => {
  const target = e.target as HTMLInputElement;
  const value = target.value.replace(/[^\d]/g, '');
  birthNumberBack.value = value;
};

// 생년월일에서 주민등록번호 앞자리 채우기
const fillBirthFrontFromBirth = () => {
  const front = extractBirthFront(editFormData.value.emp_birth);
  if (front) {
    birthNumberFront.value = front;
  }
};

// 주소 검색 (상세 모달 수정 모드용)
const loadDaumPostcodeScript = async (): Promise<void> => {
  if ((window as any).daum?.Postcode) return;
  if (daumScriptLoading) {
    await daumScriptLoading;
    return;
  }
  daumScriptLoading = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Daum Postcode script load failed'));
    document.head.appendChild(script);
  });
  await daumScriptLoading;
};

const embedDaumPostcode = async () => {
  addressLoading.value = true;
  try {
    await loadDaumPostcodeScript();
    await nextTick();
    const container = postcodeContainer.value;
    if (!container) throw new Error('Container not ready');
    container.innerHTML = '';
    const Postcode = (window as any).daum?.Postcode;
    if (!Postcode) throw new Error('Daum Postcode is undefined');
    const postcode = new Postcode({
      oncomplete: (data: any) => {
        const road = data.roadAddress;
        const jibun = data.jibunAddress;
        const selected = road && road.length > 0 ? road : jibun;
        
        editFormData.value.emp_addr = selected || '';
        
        addressDialog.value = false;
        addressLoading.value = false;
      },
      onresize: (size: any) => {
        try {
          (container as HTMLDivElement).style.height = `${size.height}px`;
        } catch {}
      },
      width: '100%',
      height: '100%'
    });
    try {
      postcode.embed(container, { autoClose: true });
      addressLoading.value = false;
    } catch (e) {
      addressLoading.value = false;
      throw e;
    }
  } catch (e) {
    addressLoading.value = false;
    throw e;
  }
};

const openEditAddressModal = async () => {
  addressDialog.value = true;
};

watch(addressDialog, async (val) => {
  if (val) {
    try {
      await embedDaumPostcode();
    } catch (e) {
      addressDialog.value = false;
      store.commit('showSnackbar', {
        text: '주소 검색 로드에 실패했습니다.',
        color: 'error'
      });
    }
  }
});

watch(detailDialog, (val) => {
  if (!val) {
    resetBirthNumberState();
  }
});

// 사원 정보 업로드
const openMemberUploadDialog = () => {
  memberUploadDialog.value = true;
};

// 일정계획 캘린더 열기
const openScheduleCalendar = (employee: Employee) => {
  selectedEmployeeForSchedule.value = employee;
  scheduleCalendarDialog.value = true;
};

// 일정계획 캘린더에서 직원 변경 시
const handleScheduleEmployeeChange = (employee: Employee) => {
  selectedEmployeeForSchedule.value = employee;
};

// 일정계획 업로드 현황 조회
const fetchScheduleUploadStatus = async () => {
  if (!user.value?.m_sisul_code) return;
  
  try {
    isLoadingScheduleStatus.value = true;
    const response = await axios.get(
      `/api/files/check/${currentYear}/${user.value.m_sisul_code}`,
      { withCredentials: true }
    );
    
    if (response.data.success && response.data.data) {
      // schedule 데이터만 추출
      const statusData: Record<number, boolean> = {};
      for (let m = 1; m <= 12; m++) {
        statusData[m] = response.data.data[m]?.schedule || false;
      }
      scheduleUploadStatus.value = statusData;
    }
  } catch (error) {
    console.error('일정계획 업로드 현황 조회 오류:', error);
  } finally {
    isLoadingScheduleStatus.value = false;
  }
};

// 일정계획 업로드 관련 함수들
const openScheduleUploadDialog = () => {
  scheduleFile.value = null;
  fetchScheduleUploadStatus(); // 모달 열릴 때 현황 조회
  scheduleUploadDialog.value = true;
};

const closeScheduleUploadDialog = () => {
  if (isScheduleUploading.value) return;
  scheduleUploadDialog.value = false;
  scheduleFile.value = null;
  isScheduleDragging.value = false;
};

const triggerScheduleFileInput = () => {
  if (isScheduleUploading.value) return;
  scheduleFileInput.value?.click();
};

const handleScheduleDragOver = () => {
  if (isScheduleUploading.value) return;
  isScheduleDragging.value = true;
};

const handleScheduleDragLeave = () => {
  if (isScheduleUploading.value) return;
  isScheduleDragging.value = false;
};

const handleScheduleDrop = (event: DragEvent) => {
  if (isScheduleUploading.value) return;
  isScheduleDragging.value = false;
  const files = event.dataTransfer?.files;
  if (files && files.length > 0) {
    selectScheduleFile(files[0]);
  }
};

const handleScheduleFileSelect = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const files = target.files;
  if (files && files.length > 0) {
    selectScheduleFile(files[0]);
  }
  target.value = '';
};

const selectScheduleFile = (file: File) => {
  const ext = file.name.split('.').pop()?.toLowerCase();
  if (ext !== 'xls' && ext !== 'xlsx') {
    store.commit('showSnackbar', {
      text: '엑셀 파일만 업로드 가능해요',
      color: 'warning'
    });
    return;
  }
  scheduleFile.value = file;
};

const clearScheduleFile = () => {
  scheduleFile.value = null;
};

const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
};

const uploadScheduleFile = async () => {
  if (!scheduleFile.value || !user.value?.m_sisul_code) return;
  
  try {
    isScheduleUploading.value = true;
    
    const formData = new FormData();
    formData.append('file', scheduleFile.value);
    formData.append('institutionCode', user.value.m_sisul_code);
    formData.append('expectedFileType', '일정계획'); // 일정계획 파일만 허용
    
    const response = await axios.post('/api/files/bulk-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      withCredentials: true
    });
    
    if (response.data.success) {
      const fileYM = response.data.fileYearMonth;
      const fileYear = fileYM ? fileYM.substring(0, 4) : '';
      const fileMonth = fileYM ? parseInt(fileYM.substring(4, 6)) : '';
      
      store.commit('showSnackbar', {
        text: `✅ 일정계획 파일이 업로드되었어요! (${fileYear}년 ${fileMonth}월)`,
        color: 'success'
      });
      
      // 현황 갱신 후 모달 닫기
      await fetchScheduleUploadStatus();
      closeScheduleUploadDialog();
    } else {
      store.commit('showSnackbar', {
        text: response.data.message || '업로드에 실패했어요',
        color: 'error'
      });
    }
  } catch (error: any) {
    console.error('일정계획 업로드 오류:', error);
    console.error('응답 데이터:', error.response?.data);
    
    // 디버그 정보가 있으면 콘솔에 출력
    if (error.response?.data?.debug) {
      console.error('디버그 정보:', error.response.data.debug);
    }
    
    store.commit('showSnackbar', {
      text: error.response?.data?.message || '업로드 중 오류가 발생했어요',
      color: 'error'
    });
  } finally {
    isScheduleUploading.value = false;
  }
};

// 사원 정보 업로드 완료 핸들러
const handleMemberUploaded = async () => {
  // 업로드 완료 후 사원 목록 재조회
  await fetchEmployees();
};

// 사원 삭제 확인 모달 열기
const confirmDeleteEmployee = (employee: Employee | null) => {
  if (!employee) {
    store.commit('showSnackbar', {
      text: '삭제할 사원 정보가 없습니다.',
      color: 'error'
    });
    return;
  }
  employeeToDelete.value = employee;
  deleteDialog.value = true;
};

// 사원 삭제 실행
const deleteEmployee = async () => {
  if (!employeeToDelete.value?.emp_idx) {
    store.commit('showSnackbar', {
      text: '삭제할 사원 정보가 없습니다.',
      color: 'error'
    });
    return;
  }

  try {
    isDeleting.value = true;
    
    const response = await axios.delete(`/api/emp/facility/${employeeToDelete.value.emp_idx}`, {
      withCredentials: true
    });

    if (response.data.success) {
      store.commit('showSnackbar', {
        text: response.data.message || '사원이 삭제되었습니다.',
        color: 'success'
      });
      deleteDialog.value = false;
      detailDialog.value = false;
      employeeToDelete.value = null;
      selectedEmployee.value = null;
      await fetchEmployees();
    } else {
      store.commit('showSnackbar', {
        text: response.data.message || '사원 삭제에 실패했습니다.',
        color: 'error'
      });
    }
  } catch (error: any) {
    console.error('사원 삭제 오류:', error);
    store.commit('showSnackbar', {
      text: error.response?.data?.message || '사원 삭제 중 오류가 발생했습니다.',
      color: 'error'
    });
  } finally {
    isDeleting.value = false;
  }
};

// 컴포넌트 마운트
onMounted(async () => {
  try {
    await store.dispatch('validateAuth');
    
    // 사용자 정보 확인
    if (!user.value?.m_sisul_code) {
      console.error('사용자 정보가 없습니다:', user.value);
      store.commit('showSnackbar', {
        text: '사용자 정보를 불러올 수 없습니다. 다시 로그인해주세요.',
        color: 'error'
      });
      return;
    }
    
    await fetchEmployees();
  } catch (error) {
    console.error('컴포넌트 마운트 중 오류:', error);
    store.commit('showSnackbar', {
      text: '페이지 초기화 중 오류가 발생했습니다.',
      color: 'error'
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_LodingComponent = _resolveComponent("LodingComponent")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LodingComponent, {
      "is-visible": isLoading.value,
      text: loadingText.value
    }, null, 8, ["is-visible", "text"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[36] || (_cache[36] = _createElementVNode("h1", { class: "page-title" }, "사원 관리", -1)),
          _createElementVNode("span", _hoisted_5, "재직 중 " + _toDisplayString(employeesSummary.value.active) + "명", 1)
        ]),
        _cache[37] || (_cache[37] = _createElementVNode("p", { class: "page-subtitle" }, "기관 소속 사원 정보를 관리하세요", -1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_menu, null, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps({
              color: "#1e3a8a",
              variant: "outlined",
              "prepend-icon": "mdi-file-download"
            }, props, { class: "mr-2" }), {
              default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                _createTextVNode(" 자료 다운로드 ", -1)
              ]))]),
              _: 1
            }, 16)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, {
              density: "compact",
              class: "download-menu"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(downloadableFiles, (file) => {
                  return _createVNode(_component_v_list_item, {
                    key: file.name,
                    onClick: ($event: any) => (downloadFile(file))
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "20",
                        color: "#1e3a8a"
                      }, {
                        default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                          _createTextVNode("mdi-file-document", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(file.label), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                }), 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          color: "#1e3a8a",
          variant: "outlined",
          "prepend-icon": "mdi-account-key",
          onClick: openBulkCredentialDialog,
          class: "mr-2"
        }, {
          default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
            _createTextVNode(" 계정부여 ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          color: "#1e3a8a",
          variant: "outlined",
          "prepend-icon": "mdi-account-group",
          onClick: openMemberUploadDialog,
          class: "mr-2"
        }, {
          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
            _createTextVNode(" 사원정보 업로드 ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          color: "#059669",
          variant: "outlined",
          "prepend-icon": "mdi-calendar",
          onClick: openScheduleUploadDialog,
          class: "mr-2"
        }, {
          default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
            _createTextVNode(" 일정계획 업로드 ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          color: "#1e3a8a",
          variant: "flat",
          "prepend-icon": "mdi-account-plus",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openEmployeeDialog(null)))
        }, {
          default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
            _createTextVNode(" 신규 등록 ", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_v_card, {
      class: "filter-card",
      elevation: "1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_v_text_field, {
                modelValue: filters.value.keyword,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.keyword) = $event)),
                variant: "outlined",
                density: "compact",
                "prepend-inner-icon": "mdi-magnify",
                placeholder: "이름, 사원코드, 연락처",
                clearable: "",
                "hide-details": "",
                class: "filter-input"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_select, {
                modelValue: filters.value.job,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.job) = $event)),
                items: jobOptions,
                variant: "outlined",
                density: "compact",
                placeholder: "직종 선택",
                clearable: "",
                "hide-details": "",
                class: "filter-input"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_select, {
                modelValue: filters.value.status,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.status) = $event)),
                items: statusOptions,
                "item-title": "label",
                "item-value": "value",
                variant: "outlined",
                density: "compact",
                placeholder: "재직 상태",
                clearable: "",
                "hide-details": "",
                class: "filter-input"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: resetFilters,
                class: "reset-btn"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    size: "18",
                    class: "mr-1"
                  }, {
                    default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                      _createTextVNode("mdi-refresh", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[45] || (_cache[45] = _createTextVNode(" 초기화 ", -1))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      class: "table-card",
      elevation: "1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_data_table, {
          headers: headers,
          items: filteredEmployees.value,
          loading: isLoading.value,
          "items-per-page": -1,
          "hide-default-footer": "",
          class: "employees-table",
          density: "comfortable"
        }, {
          "item.emp_name": _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_v_avatar, {
                size: "32",
                color: "#1e3a8a",
                class: "mr-2"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(item.emp_name.charAt(0)), 1)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("span", _hoisted_10, _toDisplayString(item.emp_name), 1)
            ])
          ]),
          "item.emp_id": _withCtx(({ item }) => [
            _createElementVNode("span", {
              class: _normalizeClass({ 'no-id': !item.emp_id })
            }, _toDisplayString(item.emp_id || '-'), 3)
          ]),
          "item.emp_birth": _withCtx(({ item }) => [
            _createElementVNode("span", null, _toDisplayString(formatBirth(item.emp_birth)), 1)
          ]),
          "item.emp_phone": _withCtx(({ item }) => [
            _createElementVNode("span", null, _toDisplayString(item.emp_phone || '-'), 1)
          ]),
          "item.emp_in_date": _withCtx(({ item }) => [
            _createElementVNode("span", null, _toDisplayString(item.emp_in_date || '-'), 1)
          ]),
          "item.emp_out_date": _withCtx(({ item }) => [
            _createElementVNode("span", null, _toDisplayString(item.emp_out_date || '-'), 1)
          ]),
          "item.documents": _withCtx(({ item }) => [
            _createElementVNode("div", {
              class: "document-status-cell",
              onClick: ($event: any) => (openDocumentDialog(item))
            }, [
              ((item.has_resignation ?? 0) > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["resignation-indicator", item.resignation_status || ''])
                  }, [
                    _createVNode(_component_v_icon, {
                      size: "16",
                      color: "white"
                    }, {
                      default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                        _createTextVNode("mdi-file-remove", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(getResignationBadgeText(item.resignation_status || '')), 1)
                  ], 2))
                : ((item.doc_count ?? 0) > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_v_icon, {
                        size: "16",
                        color: "#1e3a8a"
                      }, {
                        default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                          _createTextVNode("mdi-file-document", -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("span", null, _toDisplayString(item.doc_count) + "건", 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_v_icon, {
                        size: "16",
                        color: "#9ca3af"
                      }, {
                        default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                          _createTextVNode("mdi-file-document-outline", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[49] || (_cache[49] = _createElementVNode("span", null, "-", -1))
                    ])),
              _createVNode(_component_v_tooltip, {
                activator: "parent",
                location: "top"
              }, {
                default: _withCtx(() => [
                  ((item.has_resignation ?? 0) > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" 📄 사직서 " + _toDisplayString(getDocStatusText(item.resignation_status || '')), 1),
                        _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1)),
                        _cache[51] || (_cache[51] = _createTextVNode(" 클릭하여 상세 보기 ", -1))
                      ], 64))
                    : ((item.doc_count ?? 0) > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" 문서 " + _toDisplayString(item.doc_count) + "건", 1),
                          _cache[52] || (_cache[52] = _createElementVNode("br", null, null, -1)),
                          _cache[53] || (_cache[53] = _createTextVNode(" 클릭하여 상세 보기 ", -1))
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(" 제출된 문서 없음 ")
                        ], 64))
                ]),
                _: 2
              }, 1024)
            ], 8, _hoisted_11)
          ]),
          "item.actions": _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_v_btn, {
                icon: "",
                size: "small",
                variant: "text",
                onClick: ($event: any) => (viewEmployeeDetail(item))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                      _createTextVNode("mdi-information", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, {
                    activator: "parent",
                    location: "top"
                  }, {
                    default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                      _createTextVNode("상세정보", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_btn, {
                icon: "",
                size: "small",
                variant: "text",
                onClick: ($event: any) => (openScheduleCalendar(item))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                      _createTextVNode("mdi-calendar-clock", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, {
                    activator: "parent",
                    location: "top"
                  }, {
                    default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                      _createTextVNode("일정계획", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["items", "loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: detailDialog.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((detailDialog).value = $event)),
      "max-width": "700px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "detail-modal-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "detail-header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_v_avatar, {
                    size: "48",
                    color: "white",
                    class: "mr-3"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(selectedEmployee.value?.emp_name?.charAt(0)), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("h2", null, _toDisplayString(selectedEmployee.value?.emp_name), 1),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(selectedEmployee.value?.emp_job), 1)
                  ])
                ])
              ]),
              _: 1
            }),
            (selectedEmployee.value)
              ? (_openBlock(), _createBlock(_component_v_card_text, {
                  key: 0,
                  class: "detail-content"
                }, {
                  default: _withCtx(() => [
                    (!isEditMode.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_v_icon, {
                                size: "20",
                                color: "#1e3a8a"
                              }, {
                                default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                  _createTextVNode("mdi-account", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[59] || (_cache[59] = _createElementVNode("span", null, "기본 정보", -1))
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _cache[60] || (_cache[60] = _createElementVNode("div", { class: "info-label" }, "이름", -1)),
                                _createElementVNode("div", _hoisted_24, _toDisplayString(selectedEmployee.value.emp_name), 1)
                              ]),
                              _createElementVNode("div", _hoisted_25, [
                                _cache[61] || (_cache[61] = _createElementVNode("div", { class: "info-label" }, "생년월일", -1)),
                                _createElementVNode("div", _hoisted_26, _toDisplayString(formatBirth(selectedEmployee.value.emp_birth)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _cache[62] || (_cache[62] = _createElementVNode("div", { class: "info-label" }, "주민등록번호", -1)),
                                _createElementVNode("div", _hoisted_28, [
                                  (selectedEmployee.value.has_birth_number)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (birthNumberState.value.visible)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(formatBirthNumber(birthNumberState.value.value, selectedEmployee.value.emp_birth)), 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(getBirthNumberMaskedText()), 1)),
                                        (selectedEmployee.value?.emp_idx)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 2,
                                              class: "reveal-btn",
                                              size: "x-small",
                                              color: "#1e3a8a",
                                              variant: "tonal",
                                              loading: birthNumberState.value.loading,
                                              onClick: toggleBirthNumberVisibility
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(birthNumberState.value.visible ? '숨기기' : '보기'), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["loading"]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_31, "미등록"))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_32, [
                                _cache[63] || (_cache[63] = _createElementVNode("div", { class: "info-label" }, "직종", -1)),
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("span", _hoisted_34, _toDisplayString(selectedEmployee.value.emp_job), 1)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_component_v_icon, {
                                size: "20",
                                color: "#1e3a8a"
                              }, {
                                default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                                  _createTextVNode("mdi-phone", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[65] || (_cache[65] = _createElementVNode("span", null, "연락처 정보", -1))
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _cache[66] || (_cache[66] = _createElementVNode("div", { class: "info-label" }, "휴대폰번호", -1)),
                                _createElementVNode("div", _hoisted_39, [
                                  (selectedEmployee.value.emp_phone)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(selectedEmployee.value.emp_phone), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_41, "-"))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_42, [
                                _cache[67] || (_cache[67] = _createElementVNode("div", { class: "info-label" }, "이메일", -1)),
                                _createElementVNode("div", _hoisted_43, [
                                  (selectedEmployee.value.emp_email)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(selectedEmployee.value.emp_email), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_45, "-"))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_46, [
                                _cache[68] || (_cache[68] = _createElementVNode("div", { class: "info-label" }, "주소", -1)),
                                _createElementVNode("div", _hoisted_47, [
                                  (selectedEmployee.value.emp_addr)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(selectedEmployee.value.emp_addr) + " " + _toDisplayString(selectedEmployee.value.emp_addr_detail ? ` ${selectedEmployee.value.emp_addr_detail}` : ''), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_49, "-"))
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("div", _hoisted_51, [
                              _createVNode(_component_v_icon, {
                                size: "20",
                                color: "#1e3a8a"
                              }, {
                                default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                                  _createTextVNode("mdi-briefcase", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[70] || (_cache[70] = _createElementVNode("span", null, "재직 정보", -1))
                            ]),
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("div", _hoisted_53, [
                                _cache[71] || (_cache[71] = _createElementVNode("div", { class: "info-label" }, "입사일", -1)),
                                _createElementVNode("div", _hoisted_54, [
                                  (selectedEmployee.value.emp_in_date)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(selectedEmployee.value.emp_in_date), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_56, "-"))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_57, [
                                _cache[72] || (_cache[72] = _createElementVNode("div", { class: "info-label" }, "퇴사일", -1)),
                                _createElementVNode("div", _hoisted_58, [
                                  (selectedEmployee.value.emp_out_date)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(selectedEmployee.value.emp_out_date), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_60, "재직 중"))
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("div", _hoisted_62, [
                              _createVNode(_component_v_icon, {
                                size: "20",
                                color: "#1e3a8a"
                              }, {
                                default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                                  _createTextVNode("mdi-account-key", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[74] || (_cache[74] = _createElementVNode("span", null, "계정 정보", -1))
                            ]),
                            _createElementVNode("div", _hoisted_63, [
                              (credentialState.value.hasAccount)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                    _createVNode(_component_v_icon, {
                                      size: "28",
                                      color: "#16a34a"
                                    }, {
                                      default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
                                        _createTextVNode("mdi-check-circle", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_65, [
                                      _cache[76] || (_cache[76] = _createElementVNode("span", { class: "status-text" }, "계정 등록됨", -1)),
                                      _createElementVNode("span", _hoisted_66, "ID: " + _toDisplayString(credentialState.value.empId), 1)
                                    ]),
                                    _createVNode(_component_v_btn, {
                                      size: "small",
                                      color: "#1e3a8a",
                                      variant: "tonal",
                                      onClick: openCredentialDialog
                                    }, {
                                      default: _withCtx(() => [...(_cache[77] || (_cache[77] = [
                                        _createTextVNode(" 계정 수정 ", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                    _createVNode(_component_v_icon, {
                                      size: "28",
                                      color: "#9ca3af"
                                    }, {
                                      default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                                        _createTextVNode("mdi-account-off", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[81] || (_cache[81] = _createElementVNode("div", { class: "account-details" }, [
                                      _createElementVNode("span", { class: "status-text" }, "계정 미등록"),
                                      _createElementVNode("span", { class: "status-desc" }, "앱 로그인이 불가합니다")
                                    ], -1)),
                                    _createVNode(_component_v_btn, {
                                      size: "small",
                                      color: "#1e3a8a",
                                      variant: "flat",
                                      onClick: openCredentialDialog
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          size: "16",
                                          class: "mr-1"
                                        }, {
                                          default: _withCtx(() => [...(_cache[79] || (_cache[79] = [
                                            _createTextVNode("mdi-account-key", -1)
                                          ]))]),
                                          _: 1
                                        }),
                                        _cache[80] || (_cache[80] = _createTextVNode(" 계정 부여 ", -1))
                                      ]),
                                      _: 1
                                    })
                                  ]))
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, [
                            _cache[89] || (_cache[89] = _createElementVNode("h4", { class: "section-title" }, "기본 정보", -1)),
                            _createElementVNode("div", _hoisted_70, [
                              _cache[82] || (_cache[82] = _createElementVNode("label", { class: "compact-label" }, "이름 *", -1)),
                              _createElementVNode("div", _hoisted_71, _toDisplayString(editFormData.value.emp_name || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_72, [
                              _cache[83] || (_cache[83] = _createElementVNode("label", { class: "compact-label" }, "생년월일 *", -1)),
                              _createElementVNode("div", _hoisted_73, _toDisplayString(formatBirth(editFormData.value.emp_birth) || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_74, [
                              _cache[87] || (_cache[87] = _createElementVNode("label", { class: "compact-label" }, "주민등록번호", -1)),
                              _createElementVNode("div", _hoisted_75, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((birthNumberFront).value = $event)),
                                  type: "text",
                                  class: "compact-input birth-front",
                                  maxlength: "6",
                                  placeholder: "앞자리 6자리",
                                  onInput: onEditBirthNumberFrontInput
                                }, null, 544), [
                                  [_vModelText, birthNumberFront.value]
                                ]),
                                _cache[84] || (_cache[84] = _createElementVNode("span", { class: "birth-separator" }, "-", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((birthNumberBack).value = $event)),
                                  type: "text",
                                  class: "compact-input birth-back",
                                  maxlength: "7",
                                  placeholder: "뒷자리 7자리",
                                  onInput: onEditBirthNumberBackInput
                                }, null, 544), [
                                  [_vModelText, birthNumberBack.value]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_76, [
                                _createTextVNode(" 현재 상태: " + _toDisplayString(getBirthNumberStatusText()) + ". ", 1),
                                (editFormData.value.emp_birth)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      size: "x-small",
                                      variant: "text",
                                      color: "#1e3a8a",
                                      class: "ml-1",
                                      onClick: fillBirthFrontFromBirth
                                    }, {
                                      default: _withCtx(() => [...(_cache[85] || (_cache[85] = [
                                        _createTextVNode(" 생년월일에서 앞자리 채우기 ", -1)
                                      ]))]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              (hasBirthNumberRegistered.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                    _createVNode(_component_v_btn, {
                                      size: "small",
                                      variant: "text",
                                      color: "#1e3a8a",
                                      loading: birthNumberState.value.loading,
                                      onClick: fillBirthNumberForEdit
                                    }, {
                                      default: _withCtx(() => [...(_cache[86] || (_cache[86] = [
                                        _createTextVNode(" 기존 값 불러오기 ", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["loading"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_78, [
                              _cache[88] || (_cache[88] = _createElementVNode("label", { class: "compact-label" }, "직종 *", -1)),
                              _createVNode(_component_v_select, {
                                modelValue: editFormData.value.emp_job,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editFormData.value.emp_job) = $event)),
                                items: jobOptions,
                                variant: "outlined",
                                density: "compact",
                                placeholder: "직종을 선택하세요",
                                "hide-details": "",
                                "menu-props": { zIndex: 9999 }
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_79, [
                            _cache[92] || (_cache[92] = _createElementVNode("h4", { class: "section-title" }, "연락처 정보", -1)),
                            _createElementVNode("div", _hoisted_80, [
                              _cache[90] || (_cache[90] = _createElementVNode("label", { class: "compact-label" }, "휴대폰번호", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editFormData.value.emp_phone) = $event)),
                                type: "text",
                                class: "compact-input",
                                maxlength: "13",
                                onInput: onEditPhoneInput
                              }, null, 544), [
                                [_vModelText, editFormData.value.emp_phone]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_81, [
                              _cache[91] || (_cache[91] = _createElementVNode("label", { class: "compact-label" }, "이메일", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editFormData.value.emp_email) = $event)),
                                type: "email",
                                class: "compact-input",
                                maxlength: "50"
                              }, null, 512), [
                                [_vModelText, editFormData.value.emp_email]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_82, [
                            _cache[95] || (_cache[95] = _createElementVNode("h4", { class: "section-title" }, "주소 정보", -1)),
                            _createElementVNode("div", _hoisted_83, [
                              _cache[93] || (_cache[93] = _createElementVNode("label", { class: "compact-label" }, "주소", -1)),
                              _createElementVNode("div", _hoisted_84, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editFormData.value.emp_addr) = $event)),
                                  type: "text",
                                  class: "compact-input",
                                  placeholder: "주소 검색 버튼을 클릭하세요",
                                  readonly: "",
                                  onClick: openEditAddressModal
                                }, null, 512), [
                                  [_vModelText, editFormData.value.emp_addr]
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "address-search-btn",
                                  onClick: openEditAddressModal
                                }, " 주소검색 ")
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_85, [
                              _cache[94] || (_cache[94] = _createElementVNode("label", { class: "compact-label" }, "상세주소", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((editFormData.value.emp_addr_detail) = $event)),
                                type: "text",
                                class: "compact-input",
                                placeholder: "상세주소를 입력하세요",
                                maxlength: "50"
                              }, null, 512), [
                                [_vModelText, editFormData.value.emp_addr_detail]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_86, [
                            _cache[98] || (_cache[98] = _createElementVNode("h4", { class: "section-title" }, "재직 정보", -1)),
                            _createElementVNode("div", _hoisted_87, [
                              _cache[96] || (_cache[96] = _createElementVNode("label", { class: "compact-label" }, "입사일", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editFormData.value.emp_in_date) = $event)),
                                type: "date",
                                class: "compact-input"
                              }, null, 512), [
                                [_vModelText, editFormData.value.emp_in_date]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_88, [
                              _cache[97] || (_cache[97] = _createElementVNode("label", { class: "compact-label" }, "퇴사일", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((editFormData.value.emp_out_date) = $event)),
                                type: "date",
                                class: "compact-input"
                              }, null, 512), [
                                [_vModelText, editFormData.value.emp_out_date]
                              ])
                            ])
                          ])
                        ]))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_card_actions, { class: "pa-4" }, {
              default: _withCtx(() => [
                (!isEditMode.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      variant: "text",
                      color: "error",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (confirmDeleteEmployee(selectedEmployee.value)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "mr-1" }, {
                          default: _withCtx(() => [...(_cache[99] || (_cache[99] = [
                            _createTextVNode("mdi-delete", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[100] || (_cache[100] = _createTextVNode(" 삭제 ", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_spacer),
                (!isEditMode.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      variant: "text",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (detailDialog.value = false))
                    }, {
                      default: _withCtx(() => [...(_cache[101] || (_cache[101] = [
                        _createTextVNode(" 닫기 ", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!isEditMode.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 2,
                      color: "#1e3a8a",
                      variant: "flat",
                      onClick: startEdit
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "mr-1" }, {
                          default: _withCtx(() => [...(_cache[102] || (_cache[102] = [
                            _createTextVNode("mdi-pencil", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[103] || (_cache[103] = _createTextVNode(" 수정하기 ", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (isEditMode.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 3,
                      variant: "text",
                      onClick: cancelEdit,
                      disabled: isSaving.value
                    }, {
                      default: _withCtx(() => [...(_cache[104] || (_cache[104] = [
                        _createTextVNode(" 취소 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (isEditMode.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 4,
                      color: "#1e3a8a",
                      variant: "flat",
                      onClick: saveEdit,
                      loading: isSaving.value,
                      disabled: !isEditFormValid.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "mr-1" }, {
                          default: _withCtx(() => [...(_cache[105] || (_cache[105] = [
                            _createTextVNode("mdi-content-save", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[106] || (_cache[106] = _createTextVNode(" 저장 ", -1))
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(EmployeeFormModal, {
      modelValue: employeeDialog.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((employeeDialog).value = $event)),
      employee: editingEmployee.value,
      onSaved: handleEmployeeSaved
    }, null, 8, ["modelValue", "employee"]),
    _createVNode(MemberUploadModal, {
      modelValue: memberUploadDialog.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((memberUploadDialog).value = $event)),
      onUploaded: handleMemberUploaded
    }, null, 8, ["modelValue"]),
    _createVNode(ScheduleCalendarModal, {
      modelValue: scheduleCalendarDialog.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((scheduleCalendarDialog).value = $event)),
      employee: selectedEmployeeForSchedule.value,
      employees: filteredEmployees.value,
      onChangeEmployee: handleScheduleEmployeeChange
    }, null, 8, ["modelValue", "employee", "employees"]),
    _createVNode(_component_v_dialog, {
      modelValue: deleteDialog.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((deleteDialog).value = $event)),
      "max-width": "500px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "delete-confirm-header" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "white",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [...(_cache[107] || (_cache[107] = [
                    _createTextVNode("mdi-alert", -1)
                  ]))]),
                  _: 1
                }),
                _cache[108] || (_cache[108] = _createTextVNode(" 사원 삭제 확인 ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "pa-6" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_89, [
                  _createVNode(_component_v_icon, {
                    color: "error",
                    size: "48",
                    class: "mb-3"
                  }, {
                    default: _withCtx(() => [...(_cache[109] || (_cache[109] = [
                      _createTextVNode("mdi-alert-circle", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[113] || (_cache[113] = _createElementVNode("p", { class: "text-h6 mb-2" }, "정말 삭제하시겠습니까?", -1)),
                  _createElementVNode("p", _hoisted_90, [
                    _createElementVNode("strong", null, _toDisplayString(employeeToDelete.value?.emp_name), 1),
                    _cache[110] || (_cache[110] = _createTextVNode(" 사원을 삭제합니다.", -1)),
                    _cache[111] || (_cache[111] = _createElementVNode("br", null, null, -1)),
                    _cache[112] || (_cache[112] = _createTextVNode(" 삭제된 사원은 목록에서 제외됩니다. ", -1))
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (deleteDialog.value = false)),
                  disabled: isDeleting.value
                }, {
                  default: _withCtx(() => [...(_cache[114] || (_cache[114] = [
                    _createTextVNode(" 취소 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  color: "error",
                  variant: "flat",
                  onClick: deleteEmployee,
                  loading: isDeleting.value
                }, {
                  default: _withCtx(() => [...(_cache[115] || (_cache[115] = [
                    _createTextVNode(" 삭제 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: credentialDialog.value,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((credentialDialog).value = $event)),
      "max-width": "450px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "credential-header" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "white",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [...(_cache[116] || (_cache[116] = [
                    _createTextVNode("mdi-account-key", -1)
                  ]))]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(credentialState.value.hasAccount ? '사원 계정 수정' : '사원 계정 부여'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "credential-content" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_91, [
                  _createVNode(_component_v_avatar, {
                    size: "40",
                    color: "#1e3a8a",
                    class: "mr-3"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_92, _toDisplayString(selectedEmployee.value?.emp_name?.charAt(0)), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_93, _toDisplayString(selectedEmployee.value?.emp_name), 1),
                    _createElementVNode("div", _hoisted_94, _toDisplayString(selectedEmployee.value?.emp_job), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("div", _hoisted_96, [
                    _cache[117] || (_cache[117] = _createElementVNode("label", { class: "compact-label" }, "아이디 *", -1)),
                    _createElementVNode("div", _hoisted_97, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((credentialForm.value.emp_id) = $event)),
                        type: "text",
                        class: "compact-input",
                        placeholder: "4~20자의 영문, 숫자",
                        maxlength: "20",
                        onInput: onCredentialIdInput,
                        disabled: isCheckingId.value || isAssigningCredential.value
                      }, null, 40, _hoisted_98), [
                        [_vModelText, credentialForm.value.emp_id]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "id-check-btn",
                        disabled: !credentialForm.value.emp_id || credentialForm.value.emp_id.length < 4 || isCheckingId.value,
                        onClick: checkIdDuplicate
                      }, _toDisplayString(isCheckingId.value ? '확인 중...' : '중복확인'), 9, _hoisted_99)
                    ]),
                    (idCheckResult.value.checked)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["field-message", { success: idCheckResult.value.available, error: !idCheckResult.value.available }])
                        }, _toDisplayString(idCheckResult.value.message), 3))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_100, [
                    _cache[118] || (_cache[118] = _createElementVNode("label", { class: "compact-label" }, "비밀번호 *", -1)),
                    _createElementVNode("div", _hoisted_101, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((credentialForm.value.emp_pw) = $event)),
                        type: showPassword.value ? 'text' : 'password',
                        class: "compact-input",
                        placeholder: "4자 이상",
                        maxlength: "30",
                        disabled: isAssigningCredential.value
                      }, null, 8, _hoisted_102), [
                        [_vModelDynamic, credentialForm.value.emp_pw]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "password-toggle-btn",
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (showPassword.value = !showPassword.value))
                      }, [
                        _createVNode(_component_v_icon, { size: "18" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(showPassword.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_103, [
                    _cache[119] || (_cache[119] = _createElementVNode("label", { class: "compact-label" }, "비밀번호 확인 *", -1)),
                    _createElementVNode("div", _hoisted_104, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((credentialForm.value.emp_pw_confirm) = $event)),
                        type: showPasswordConfirm.value ? 'text' : 'password',
                        class: "compact-input",
                        placeholder: "비밀번호 다시 입력",
                        maxlength: "30",
                        disabled: isAssigningCredential.value
                      }, null, 8, _hoisted_105), [
                        [_vModelDynamic, credentialForm.value.emp_pw_confirm]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "password-toggle-btn",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (showPasswordConfirm.value = !showPasswordConfirm.value))
                      }, [
                        _createVNode(_component_v_icon, { size: "18" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(showPasswordConfirm.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    (credentialForm.value.emp_pw && credentialForm.value.emp_pw_confirm)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["field-message", { success: isPasswordMatch.value, error: !isPasswordMatch.value }])
                        }, _toDisplayString(isPasswordMatch.value ? '비밀번호가 일치합니다.' : '비밀번호가 일치하지 않습니다.'), 3))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: closeCredentialDialog,
                  disabled: isAssigningCredential.value
                }, {
                  default: _withCtx(() => [...(_cache[120] || (_cache[120] = [
                    _createTextVNode(" 취소 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  color: "#1e3a8a",
                  variant: "flat",
                  onClick: assignCredentials,
                  loading: isAssigningCredential.value,
                  disabled: !isCredentialFormValid.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { class: "mr-1" }, {
                      default: _withCtx(() => [...(_cache[121] || (_cache[121] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(credentialState.value.hasAccount ? '수정' : '부여'), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: documentDialog.value,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((documentDialog).value = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "document-modal-header" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "white",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [...(_cache[122] || (_cache[122] = [
                    _createTextVNode("mdi-file-document-multiple", -1)
                  ]))]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(selectedEmployeeForDoc.value?.emp_name) + " 문서함 ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "document-modal-content" }, {
              default: _withCtx(() => [
                (isLoadingDocuments.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                      _createVNode(_component_v_progress_circular, {
                        indeterminate: "",
                        color: "#1e3a8a"
                      }),
                      _cache[123] || (_cache[123] = _createElementVNode("span", null, "문서를 불러오는 중...", -1))
                    ]))
                  : (employeeDocuments.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                        _createVNode(_component_v_icon, {
                          size: "48",
                          color: "#9ca3af"
                        }, {
                          default: _withCtx(() => [...(_cache[124] || (_cache[124] = [
                            _createTextVNode("mdi-file-document-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[125] || (_cache[125] = _createElementVNode("p", null, "제출된 문서가 없습니다", -1))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_108, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employeeDocuments.value, (doc) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: doc.id,
                            class: "document-item",
                            onClick: ($event: any) => (viewDocumentDetail(doc))
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["doc-icon", doc.type])
                            }, [
                              _createVNode(_component_v_icon, {
                                size: "24",
                                color: "white"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(doc.type === 'resignation' ? 'mdi-file-remove' : 'mdi-file-document'), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ], 2),
                            _createElementVNode("div", _hoisted_110, [
                              _createElementVNode("span", _hoisted_111, _toDisplayString(doc.type === 'resignation' ? '사직서' : doc.type), 1),
                              _createElementVNode("span", _hoisted_112, _toDisplayString(formatDocDate(doc.date)), 1)
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["doc-status", doc.status])
                            }, _toDisplayString(getDocStatusText(doc.status)), 3),
                            _createVNode(_component_v_icon, {
                              size: "20",
                              color: "#9ca3af"
                            }, {
                              default: _withCtx(() => [...(_cache[126] || (_cache[126] = [
                                _createTextVNode("mdi-chevron-right", -1)
                              ]))]),
                              _: 1
                            })
                          ], 8, _hoisted_109))
                        }), 128))
                      ]))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[27] || (_cache[27] = ($event: any) => (documentDialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[127] || (_cache[127] = [
                    _createTextVNode("닫기", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: documentDetailDialog.value,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((documentDetailDialog).value = $event)),
      "max-width": "500px"
    }, {
      default: _withCtx(() => [
        (selectedDocument.value)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              class: "resignation-detail-card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_113, [
                  _cache[129] || (_cache[129] = _createElementVNode("h2", null, "사 직 서", -1)),
                  _createElementVNode("button", {
                    class: "close-btn",
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (documentDetailDialog.value = false))
                  }, [
                    _createVNode(_component_v_icon, { color: "white" }, {
                      default: _withCtx(() => [...(_cache[128] || (_cache[128] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_114, [
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("div", _hoisted_116, [
                      _cache[130] || (_cache[130] = _createElementVNode("span", { class: "form-label" }, "소 속 :", -1)),
                      _createElementVNode("span", _hoisted_117, _toDisplayString(selectedDocument.value.content?.sisul_name || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_118, [
                      _cache[131] || (_cache[131] = _createElementVNode("span", { class: "form-label" }, "직 위 :", -1)),
                      _createElementVNode("span", _hoisted_119, _toDisplayString(selectedDocument.value.content?.emp_job || selectedDocument.value.emp_job || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_120, [
                      _cache[132] || (_cache[132] = _createElementVNode("span", { class: "form-label" }, "성 명 :", -1)),
                      _createElementVNode("span", _hoisted_121, _toDisplayString(selectedDocument.value.content?.emp_name || selectedDocument.value.emp_name || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_122, [
                      _cache[133] || (_cache[133] = _createElementVNode("span", { class: "form-label" }, "사직사유 :", -1)),
                      _createElementVNode("span", _hoisted_123, _toDisplayString(selectedDocument.value.content?.resign_reason || '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_124, [
                    _cache[135] || (_cache[135] = _createElementVNode("p", null, "상기 본인은 위와 같은 사정으로 인하여", -1)),
                    _createElementVNode("p", _hoisted_125, [
                      _createElementVNode("strong", null, _toDisplayString(formatResignDate(selectedDocument.value.resign_date)), 1),
                      _cache[134] || (_cache[134] = _createTextVNode(" 부로 ", -1))
                    ]),
                    _cache[136] || (_cache[136] = _createElementVNode("p", null, "사직하고자 이에 사직서를 제출합니다.", -1))
                  ]),
                  _createElementVNode("div", _hoisted_126, _toDisplayString(formatDocDate(selectedDocument.value.submit_date)), 1),
                  _createElementVNode("div", _hoisted_127, [
                    _cache[137] || (_cache[137] = _createElementVNode("span", { class: "signature-label" }, "신 청 인 :", -1)),
                    (selectedDocument.value.signature_path)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                          _createElementVNode("img", {
                            src: getSignatureUrl(selectedDocument.value.signature_path),
                            alt: "서명"
                          }, null, 8, _hoisted_129)
                        ]))
                      : _createCommentVNode("", true),
                    _cache[138] || (_cache[138] = _createElementVNode("span", { class: "seal-text" }, "(인)", -1))
                  ]),
                  _createElementVNode("div", _hoisted_130, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["status-badge", selectedDocument.value.status])
                    }, _toDisplayString(getDocStatusText(selectedDocument.value.status)), 3)
                  ]),
                  _createElementVNode("button", {
                    class: _normalizeClass(["download-pdf-btn", { disabled: !selectedDocument.value.pdf_path }]),
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (downloadResignationPDF(selectedDocument.value.pdf_path))),
                    disabled: !selectedDocument.value.pdf_path
                  }, [
                    _createVNode(_component_v_icon, { size: "20" }, {
                      default: _withCtx(() => [...(_cache[139] || (_cache[139] = [
                        _createTextVNode("mdi-file-pdf-box", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(selectedDocument.value.pdf_path ? '사직서 PDF 다운로드' : 'PDF 파일 없음'), 1)
                  ], 10, _hoisted_131)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: bulkCredentialDialog.value,
      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((bulkCredentialDialog).value = $event)),
      "max-width": "800px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "bulk-credential-header" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "white",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [...(_cache[140] || (_cache[140] = [
                    _createTextVNode("mdi-account-multiple-plus", -1)
                  ]))]),
                  _: 1
                }),
                _cache[141] || (_cache[141] = _createTextVNode(" 일괄 계정 부여 ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "bulk-credential-content" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_132, [
                  _cache[150] || (_cache[150] = _createElementVNode("h4", { class: "section-title" }, "ID 생성 규칙 설정", -1)),
                  _createElementVNode("div", _hoisted_133, [
                    _createElementVNode("div", _hoisted_134, [
                      _cache[142] || (_cache[142] = _createElementVNode("label", { class: "compact-label" }, "접두사 *", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((bulkCredentialForm.value.prefix) = $event)),
                        type: "text",
                        class: "compact-input",
                        placeholder: "예: 행복요양",
                        maxlength: "20",
                        disabled: isBulkAssigning.value
                      }, null, 8, _hoisted_135), [
                        [_vModelText, bulkCredentialForm.value.prefix]
                      ]),
                      _createElementVNode("div", _hoisted_136, " 생성 예시: " + _toDisplayString(bulkIdPreview.value), 1)
                    ]),
                    _createElementVNode("div", _hoisted_137, [
                      _cache[143] || (_cache[143] = _createElementVNode("label", { class: "compact-label" }, "공통 비밀번호 *", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((bulkCredentialForm.value.password) = $event)),
                        type: "text",
                        class: "compact-input",
                        placeholder: "예: 1234",
                        maxlength: "20",
                        disabled: isBulkAssigning.value
                      }, null, 8, _hoisted_138), [
                        [_vModelText, bulkCredentialForm.value.password]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_139, [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      color: "#1e3a8a",
                      class: "mr-2"
                    }, {
                      default: _withCtx(() => [...(_cache[144] || (_cache[144] = [
                        _createTextVNode("mdi-information", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _cache[145] || (_cache[145] = _createElementVNode("strong", null, "ID 생성 규칙:", -1)),
                      _createTextVNode(" " + _toDisplayString(bulkCredentialForm.value.prefix || '접두사') + " + 이름 + 생년월일(6자리)", 1),
                      _cache[146] || (_cache[146] = _createElementVNode("br", null, null, -1)),
                      _cache[147] || (_cache[147] = _createElementVNode("strong", null, "안내 문구 예시:", -1)),
                      _createTextVNode(" \"ID는 '" + _toDisplayString(bulkCredentialForm.value.prefix || '접두사') + "'을 먼저 입력하고 본인이름과 생년월일(6자리)을 입력하시면 됩니다. 비밀번호는 " + _toDisplayString(bulkCredentialForm.value.password || '1234') + "입니다.\" ", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_140, [
                    _createVNode(_component_v_btn, {
                      color: "#1e3a8a",
                      variant: "outlined",
                      loading: isCheckingDuplicate.value,
                      disabled: !bulkCredentialForm.value.prefix || bulkSelectedEmployees.value.length === 0,
                      onClick: checkBulkDuplicate
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "mr-1" }, {
                          default: _withCtx(() => [...(_cache[148] || (_cache[148] = [
                            _createTextVNode("mdi-magnify-scan", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[149] || (_cache[149] = _createTextVNode(" 중복검사 ", -1))
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled"]),
                    (duplicateCheckResult.value.checked)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["duplicate-result", duplicateCheckResult.value.hasError ? 'has-error' : 'no-error'])
                        }, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            color: duplicateCheckResult.value.hasError ? '#dc2626' : '#16a34a',
                            class: "mr-1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(duplicateCheckResult.value.hasError ? 'mdi-alert-circle' : 'mdi-check-circle'), 1)
                            ]),
                            _: 1
                          }, 8, ["color"]),
                          _createTextVNode(" " + _toDisplayString(duplicateCheckResult.value.message), 1)
                        ], 2))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_141, [
                  _createElementVNode("div", _hoisted_142, [
                    _cache[153] || (_cache[153] = _createElementVNode("h4", { class: "section-title" }, "대상 사원 목록", -1)),
                    _createElementVNode("div", _hoisted_143, [
                      _createVNode(_component_v_btn, {
                        size: "small",
                        variant: "text",
                        color: "#1e3a8a",
                        onClick: selectAllEmployees,
                        disabled: isBulkAssigning.value
                      }, {
                        default: _withCtx(() => [...(_cache[151] || (_cache[151] = [
                          _createTextVNode(" 전체 선택 ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_v_btn, {
                        size: "small",
                        variant: "text",
                        onClick: deselectAllEmployees,
                        disabled: isBulkAssigning.value
                      }, {
                        default: _withCtx(() => [...(_cache[152] || (_cache[152] = [
                          _createTextVNode(" 전체 해제 ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_144, [
                    _createElementVNode("div", _hoisted_145, [
                      _createElementVNode("table", _hoisted_146, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", _hoisted_147, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: isAllSelected.value,
                                indeterminate: isPartiallySelected.value,
                                onChange: toggleSelectAll,
                                disabled: isBulkAssigning.value
                              }, null, 40, _hoisted_148)
                            ]),
                            _cache[154] || (_cache[154] = _createElementVNode("th", null, "이름", -1)),
                            _cache[155] || (_cache[155] = _createElementVNode("th", null, "직종", -1)),
                            _cache[156] || (_cache[156] = _createElementVNode("th", null, "생년월일", -1)),
                            _cache[157] || (_cache[157] = _createElementVNode("th", null, "현재 ID", -1)),
                            _cache[158] || (_cache[158] = _createElementVNode("th", null, "생성될 ID", -1))
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employeesWithoutAccount.value, (emp) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: emp.emp_idx,
                              class: _normalizeClass({ 
                        selected: bulkSelectedEmployees.value.includes(emp.emp_idx!),
                        'has-error': duplicateEmployees.value.includes(emp.emp_idx!)
                      })
                            }, [
                              _createElementVNode("td", _hoisted_149, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  checked: bulkSelectedEmployees.value.includes(emp.emp_idx!),
                                  onChange: ($event: any) => (toggleEmployeeSelection(emp.emp_idx!)),
                                  disabled: isBulkAssigning.value
                                }, null, 40, _hoisted_150)
                              ]),
                              _createElementVNode("td", null, [
                                _createTextVNode(_toDisplayString(emp.emp_name) + " ", 1),
                                (duplicateEmployees.value.includes(emp.emp_idx!))
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      size: "16",
                                      color: "#dc2626",
                                      class: "ml-1"
                                    }, {
                                      default: _withCtx(() => [...(_cache[159] || (_cache[159] = [
                                        _createTextVNode("mdi-alert", -1)
                                      ]))]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(emp.emp_job), 1),
                              _createElementVNode("td", null, _toDisplayString(formatBirth(emp.emp_birth)), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", _hoisted_151, [
                                  _createVNode(_component_v_icon, {
                                    size: "14",
                                    color: "#9ca3af",
                                    class: "mr-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[160] || (_cache[160] = [
                                      _createTextVNode("mdi-close-circle-outline", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[161] || (_cache[161] = _createTextVNode(" 미부여 ", -1))
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["generated-id", { 'error-id': duplicateEmployees.value.includes(emp.emp_idx!) }])
                                }, [
                                  _createTextVNode(_toDisplayString(generateBulkId(emp)) + " ", 1),
                                  (getDuplicateReason(emp.emp_idx!))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_152, " (" + _toDisplayString(getDuplicateReason(emp.emp_idx!)) + ") ", 1))
                                    : _createCommentVNode("", true)
                                ], 2)
                              ])
                            ], 2))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_153, [
                    _createElementVNode("span", null, [
                      _cache[162] || (_cache[162] = _createTextVNode("계정 미부여 사원 ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(employeesWithoutAccount.value.length) + "명", 1),
                      _cache[163] || (_cache[163] = _createTextVNode(" 중 ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(bulkSelectedEmployees.value.length) + "명", 1),
                      _cache[164] || (_cache[164] = _createTextVNode(" 선택됨", -1))
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: closeBulkCredentialDialog,
                  disabled: isBulkAssigning.value
                }, {
                  default: _withCtx(() => [...(_cache[165] || (_cache[165] = [
                    _createTextVNode(" 취소 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  color: "#1e3a8a",
                  variant: "flat",
                  onClick: assignBulkCredentials,
                  loading: isBulkAssigning.value,
                  disabled: !isBulkFormValid.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { class: "mr-1" }, {
                      default: _withCtx(() => [...(_cache[166] || (_cache[166] = [
                        _createTextVNode("mdi-account-multiple-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(bulkSelectedEmployees.value.length) + "명 계정 부여 ", 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: scheduleUploadDialog.value,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((scheduleUploadDialog).value = $event)),
      "max-width": "600px",
      persistent: isScheduleUploading.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "schedule-upload-header" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "white",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [...(_cache[167] || (_cache[167] = [
                    _createTextVNode("mdi-calendar", -1)
                  ]))]),
                  _: 1
                }),
                _cache[168] || (_cache[168] = _createTextVNode(" 일정계획 파일 업로드 ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "schedule-upload-content" }, {
              default: _withCtx(() => [
                _cache[177] || (_cache[177] = _createElementVNode("div", { class: "download-guide" }, [
                  _createElementVNode("h4", null, "파일 다운로드 안내"),
                  _createElementVNode("ol", null, [
                    _createElementVNode("li", null, [
                      _createTextVNode("장기요양정보시스템 접속 후 우측 상단 "),
                      _createElementVNode("strong", null, "기타"),
                      _createTextVNode(" > "),
                      _createElementVNode("strong", null, "엑셀 다운로드"),
                      _createTextVNode("를 클릭합니다.")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("strong", null, "일정계획"),
                      _createTextVNode(" 탭에서 "),
                      _createElementVNode("strong", null, "엑셀 다운로드"),
                      _createTextVNode(" 버튼을 눌러 파일을 저장합니다.")
                    ]),
                    _createElementVNode("li", null, [
                      _createTextVNode("브라우저 저장 창에서 "),
                      _createElementVNode("strong", null, "Ctrl + Shift + S"),
                      _createTextVNode("로 파일을 저장해 주세요.")
                    ])
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_154, [
                  _createElementVNode("div", _hoisted_155, [
                    _createElementVNode("span", _hoisted_156, _toDisplayString(_unref(currentYear)) + "년 업로드 현황", 1),
                    _createVNode(_component_v_btn, {
                      icon: "",
                      size: "x-small",
                      variant: "text",
                      onClick: fetchScheduleUploadStatus,
                      loading: isLoadingScheduleStatus.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "16" }, {
                          default: _withCtx(() => [...(_cache[169] || (_cache[169] = [
                            _createTextVNode("mdi-refresh", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _createElementVNode("div", _hoisted_157, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (m) => {
                      return _createElementVNode("div", {
                        key: m,
                        class: _normalizeClass(["month-status-item", { 'has-data': scheduleUploadStatus.value[m] }])
                      }, [
                        _createElementVNode("span", _hoisted_158, _toDisplayString(m) + "월", 1),
                        _createVNode(_component_v_icon, {
                          size: "14",
                          color: scheduleUploadStatus.value[m] ? '#059669' : '#d1d5db'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scheduleUploadStatus.value[m] ? 'mdi-check-circle' : 'mdi-circle-outline'), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"])
                      ], 2)
                    }), 64))
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["schedule-dropzone", { 'is-active': isScheduleDragging.value, 'is-disabled': isScheduleUploading.value }]),
                  onDrop: _withModifiers(handleScheduleDrop, ["prevent"]),
                  onDragover: _withModifiers(handleScheduleDragOver, ["prevent"]),
                  onDragleave: _withModifiers(handleScheduleDragLeave, ["prevent"]),
                  onClick: triggerScheduleFileInput
                }, [
                  _createVNode(_component_v_icon, {
                    size: "48",
                    color: isScheduleDragging.value ? '#059669' : '#94a3b8'
                  }, {
                    default: _withCtx(() => [...(_cache[170] || (_cache[170] = [
                      _createTextVNode("mdi-file-excel", -1)
                    ]))]),
                    _: 1
                  }, 8, ["color"]),
                  _cache[171] || (_cache[171] = _createElementVNode("h4", null, "일정계획 파일을 드래그하거나 클릭하세요", -1)),
                  _cache[172] || (_cache[172] = _createElementVNode("p", null, "엑셀 파일 (xls, xlsx)", -1))
                ], 34),
                _createElementVNode("input", {
                  ref_key: "scheduleFileInput",
                  ref: scheduleFileInput,
                  type: "file",
                  accept: ".xls,.xlsx",
                  style: {"display":"none"},
                  onChange: handleScheduleFileSelect
                }, null, 544),
                (scheduleFile.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
                      _createElementVNode("div", _hoisted_160, [
                        _createVNode(_component_v_icon, {
                          color: "#059669",
                          size: "32"
                        }, {
                          default: _withCtx(() => [...(_cache[173] || (_cache[173] = [
                            _createTextVNode("mdi-file-excel", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_161, [
                        _createElementVNode("span", _hoisted_162, _toDisplayString(scheduleFile.value.name), 1),
                        _createElementVNode("span", _hoisted_163, _toDisplayString(formatFileSize(scheduleFile.value.size)), 1)
                      ]),
                      _createVNode(_component_v_btn, {
                        icon: "",
                        size: "small",
                        variant: "text",
                        onClick: clearScheduleFile,
                        disabled: isScheduleUploading.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[174] || (_cache[174] = [
                              _createTextVNode("mdi-close", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_164, [
                  _createVNode(_component_v_icon, {
                    size: "18",
                    color: "#059669",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [...(_cache[175] || (_cache[175] = [
                      _createTextVNode("mdi-information", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[176] || (_cache[176] = _createElementVNode("div", null, [
                    _createElementVNode("strong", null, "안내:"),
                    _createTextVNode(" 장기요양정보시스템에서 다운로드한 일정계획 엑셀 파일을 업로드하세요. ")
                  ], -1))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: closeScheduleUploadDialog,
                  disabled: isScheduleUploading.value
                }, {
                  default: _withCtx(() => [...(_cache[178] || (_cache[178] = [
                    _createTextVNode(" 취소 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  color: "#059669",
                  variant: "flat",
                  onClick: uploadScheduleFile,
                  loading: isScheduleUploading.value,
                  disabled: !scheduleFile.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { class: "mr-1" }, {
                      default: _withCtx(() => [...(_cache[179] || (_cache[179] = [
                        _createTextVNode("mdi-upload", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[180] || (_cache[180] = _createTextVNode(" 업로드 ", -1))
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "persistent"])
  ]))
}
}

})